// extracted by mini-css-extract-plugin
module.exports = {"errorLogs":"styles_errorLogs__2xjp1"};